module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', [_vm._v("\n      Kontakt erstellen\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-4"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Kontaktdaten")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((_vm.felder.neuFelder), function(item, index) {
    return _c('uiKontaktField', {
      key: index,
      attrs: {
        "feld": item,
        "value": _vm.bbr[item.value]
      },
      on: {
        "dataChange": function($event) {
          return _vm.saveData.apply(void 0, arguments)
        }
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Finanzdaten")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2"
  }, [(_vm.felder.finanzFelder.showSepaMandat) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "d-flex justify-start align-center pr-2"
  }, [_c('span', {
    staticClass: "pa-2"
  }, [(_vm.bbr.sepaLastschriftmandat) ? _c('v-icon', {
    attrs: {
      "size": "64",
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]) : _c('v-icon', {
    attrs: {
      "size": "64",
      "color": "red"
    }
  }, [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('span', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v(" SEPA-Lastschriftmandat ")]), _vm._v(" "), (_vm.bbr.sepaLastschriftmandat) ? _c('v-card-subtitle', [_vm._v("\n                        " + _vm._s(_vm.$filters.date(_vm.bbr.sepaLastschriftmandat.date, "hh:mm DD.MM.YYYY")) + " Uhr\n                      ")]) : _c('v-card-subtitle', [_vm._v("\n                        Aktuell wurde noch kein SEPA-Lastschriftmandat hochgeladen.\n                      ")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.bbr.sepaLastschriftmandat) ? _c('span', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadLastschrift(_vm.bbr.sepaLastschriftmandat)
      }
    }
  }, [_c('v-icon', [_vm._v("download")])], 1)], 1) : _c('span', [_c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingLaschriftmandatHochladen
    },
    on: {
      "click": function($event) {
        return _vm.clickHochladenLastschriftmandat()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("cloud_upload")]), _vm._v("Hochladen\n                      ")], 1), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "pdf/*"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })], 1)], 1), _vm._v(" "), (_vm.loadingLaschriftmandatHochladen) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', _vm._l((_vm.felder.finanzFelder.beitrage), function(item, index) {
    return _c('uiKontaktField', {
      key: index,
      attrs: {
        "feld": item,
        "value": _vm.bbr[item.value]
      },
      on: {
        "dataChange": function($event) {
          return _vm.saveData.apply(void 0, arguments)
        }
      }
    })
  }), 1), _vm._v(" "), _c('v-row', [(_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "loading": _vm.loading_checkIban,
      "label": "IBAN"
    },
    on: {
      "change": function($event) {
        return _vm.checkIban()
      }
    },
    model: {
      value: (_vm.bbr.iban),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "iban", $$v)
      },
      expression: "bbr.iban"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "disabled": "",
      "label": "BIC",
      "placeholder": "Automatisch berechnet"
    },
    model: {
      value: (_vm.bbr.bic),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "bic", $$v)
      },
      expression: "bbr.bic"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": "Kontoinhaber",
      "append-icon": _vm.bbr.kontoinhaber ? '' : 'refresh',
      "rules": [_vm.rules.required]
    },
    on: {
      "click:append": function($event) {
        _vm.bbr.kontoinhaber = _vm.bbr.vorname + ' ' + _vm.bbr.nachname
      }
    },
    model: {
      value: (_vm.bbr.kontoinhaber),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "kontoinhaber", $$v)
      },
      expression: "bbr.kontoinhaber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": "Mandatsreferenz",
      "append-icon": _vm.bbr.mandatsreferenz ? '' : 'refresh'
    },
    on: {
      "click:append": function($event) {
        return _vm.calcMandatsreferenz()
      }
    },
    model: {
      value: (_vm.bbr.mandatsreferenz),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "mandatsreferenz", $$v)
      },
      expression: "bbr.mandatsreferenz"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('uiKontaktField', {
    attrs: {
      "feld": {
        breite: 6,
        label: 'Mandat Unterschriftsdatum',
        type: 'Date'
      },
      "value": _vm.bbr['mandatUnterschriftsdatum']
    },
    on: {
      "dataChange": function($event) {
        return _vm.saveData.apply(void 0, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('uiKontaktField', {
    attrs: {
      "feld": {
        breite: 6,
        label: 'Letzter Lastschrifteinzug',
        type: 'Date'
      },
      "value": _vm.bbr['letzterLastschrifteinzug']
    },
    on: {
      "dataChange": function($event) {
        return _vm.saveData.apply(void 0, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fehlerSepa.sepa) ? _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.fehlerSepa.sepa))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.felder.finanzFelder.showSepaMandat) ? _c('span', [_c('v-card-title', {
    staticClass: "py-1 mt-6"
  }, [_vm._v("SEPA-Einstellungen")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "py-1"
  }, [_vm._v("Welche Kassen dürfen per SEPA Rechnungen einziehen?")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.disableSEPA) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "d-flex justify-start align-center pr-2"
  }, [_c('span', {
    staticClass: "pa-2"
  }, [_c('v-icon', {
    attrs: {
      "size": "64",
      "color": "red"
    }
  }, [_vm._v("warning_amber")])], 1), _vm._v(" "), _c('span', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v(" Kontodaten fehlen! ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n                          Damit ein SEPA-Einzug für einen Kontakt eingestellt werden kann, müssen zuerst die\n                          Kontodaten eingetragen werden.\n                        ")])], 1)])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.kassen), function(item, index) {
    return (item.name) ? _c('v-col', {
      key: index,
      staticClass: "py-1 px-1",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-checkbox', {
      staticClass: "mb-0 pb-0",
      attrs: {
        "dense": "",
        "hide-details": "",
        "disabled": _vm.disableSEPA,
        "on-icon": "check_box",
        "off-icon": "check_box_outline_blank",
        "label": item.name
      },
      model: {
        value: (_vm.sepa[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.sepa, item.name, $$v)
        },
        expression: "sepa[item.name]"
      }
    })], 1) : _vm._e()
  })], 2)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "hint": "Bemerkungen werden nur den Chargen und Ämtern angezeigt, die Zugriff auf die Kontaktbearbeitung haben.",
      "rows": "5",
      "auto-grow": "",
      "label": "Bemerkungen"
    },
    model: {
      value: (_vm.bbr.bemerkungen),
      callback: function($$v) {
        _vm.$set(_vm.bbr, "bemerkungen", $$v)
      },
      expression: "bbr.bemerkungen"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.pflichtfelder.length > 0) ? _c('span', {
    staticClass: "text-caption"
  }, [_vm._v("Folgende Felder müssen noch ausgefüllt werden:"), _c('br'), _vm._v(" "), _vm._l((_vm.pflichtfelder), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1 mt-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v(_vm._s(item))])
  })], 2) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": "",
      "disabled": _vm.pflichtfelder.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showPicture),
      callback: function($$v) {
        _vm.showPicture = $$v
      },
      expression: "showPicture"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Ahnengalerie - " + _vm._s(_vm.bbr.titel) + " " + _vm._s(_vm.bbr.vorname) + " " + _vm._s(_vm.bbr.nachname) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicture = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4",
      "offset": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm._v(" Aktuelles Bild ")]), _vm._v(" "), _c('v-img', {
    attrs: {
      "src": _vm.bbr.bildAhnengalerie,
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.showPicture = true
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm._v(" Neues Bild ")]), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Neues Bild"
    },
    on: {
      "change": _vm.previewImage
    },
    model: {
      value: (_vm.selectPicture),
      callback: function($$v) {
        _vm.selectPicture = $$v
      },
      expression: "selectPicture"
    }
  }), _vm._v(" "), _c('v-card-action', {
    staticClass: "text-center"
  }, [(_vm.message) ? _c('v-divider') : _vm._e(), _vm._v("\n                " + _vm._s(_vm.message) + "\n              ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicture = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-369ac867"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogKontaktCreate.vue
// module id = 756
// module chunks = 15